import { NgModule } from '@angular/core';
import { ProductPageEffects } from '@ecs-stores/search/result-specific/product-page/product-page.effects';
import { SparePartEffects } from '@ecs-stores/search/result-specific/spare-part/spare-part.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SearchEffects } from '../../stores/search/search.effects';
import * as fromSearch from '../../stores/search/search.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(fromSearch.searchFeatureKey, fromSearch.reducer),
        EffectsModule.forFeature([SearchEffects, ProductPageEffects, SparePartEffects]),
    ],
})
export class SearchModule {}
